module.exports = "/static/img/where_03.png?8b71e473250aede0db9b48561d8c39c2";